export const STICKY_COLORS = ["yellow", "blue", "green", "pink", "purple", "gray"];

export const STICKY_BG = {
  yellow: "rgba(254, 243, 199, 0.78)",
  blue: "rgba(219, 234, 254, 0.78)",
  green: "rgba(209, 250, 229, 0.78)",
  pink: "rgba(252, 231, 243, 0.78)",
  purple: "rgba(237, 233, 254, 0.78)",
  gray: "rgba(243, 244, 246, 0.78)",
};

export const STICKY_BG_SOLID = {
  yellow: "#FEF3C7",
  blue: "#DBEAFE",
  green: "#D1FAE5",
  pink: "#FCE7F3",
  purple: "#EDE9FE",
  gray: "#F3F4F6",
};

export const DEFAULT_STICKY = {
  width: 220,
  height: 220,
  color: "yellow",
};

/** Ink palette for freehand drawing — brand blue + ink, with pastel accents. */
export const DRAW_COLORS = [
  "#001EFF", // brand blue
  "#222222", // ink
  "#B8BEC8", // pastel graphite
  "#E8A4A4", // pastel coral
  "#8FC9B0", // pastel sage
  "#E8D08A", // pastel butter
  "#B8A8D8", // pastel lavender
];

export const BOARD_EMOJIS = ["👍", "🤍", "☺️", "🪩", "🥳", "🌞", "🤓"];

export const STICKY_REACTION_EMOJIS = BOARD_EMOJIS;

export const BOARD_TOOLS = {
  select: "select",
  draw: "draw",
  eraser: "eraser",
  emoji: "emoji",
};

/** Screen-space eraser radius; divide by canvas zoom for world coords. */
export const ERASER_RADIUS = 24;

export const MAX_BOARD_UNDO = 40;

export function newBoardId(prefix = "el") {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

export function newStickyId() {
  return newBoardId("sticky");
}

export function pointsToPath(points) {
  if (!points?.length) return "";
  return points
    .map((point, index) => {
      const x = point[0] ?? 0;
      const y = point[1] ?? 0;
      return `${index === 0 ? "M" : "L"} ${x} ${y}`;
    })
    .join(" ");
}

export function nextZIndex(elements) {
  return (elements || []).reduce((max, el) => Math.max(max, el.zIndex || 0), 0) + 1;
}

function distancePointToSegment(px, py, x1, y1, x2, y2) {
  const dx = x2 - x1;
  const dy = y2 - y1;
  if (dx === 0 && dy === 0) return Math.hypot(px - x1, py - y1);
  const t = Math.max(0, Math.min(1, ((px - x1) * dx + (py - y1) * dy) / (dx * dx + dy * dy)));
  return Math.hypot(px - (x1 + t * dx), py - (y1 + t * dy));
}

export function strokeHitTest(stroke, x, y, radius) {
  const points = stroke?.points || [];
  if (!points.length) return false;
  const hitRadius = radius + (stroke.strokeWidth || 3) / 2;
  if (points.length === 1) {
    const [px, py] = points[0];
    return Math.hypot(x - px, y - py) <= hitRadius;
  }
  for (let i = 1; i < points.length; i += 1) {
    const [x1, y1] = points[i - 1];
    const [x2, y2] = points[i];
    if (distancePointToSegment(x, y, x1, y1, x2, y2) <= hitRadius) return true;
  }
  return false;
}

export function findStrokeIdsAt(strokes, x, y, radius) {
  return strokes
    .filter((stroke) => stroke?.type === "stroke" && strokeHitTest(stroke, x, y, radius))
    .map((stroke) => stroke.id);
}
